<template>
    <v-card class="mb-2" flat>
        <v-form ref="vendorForm" v-model="validOrg" lazy-validation>
            <alert-message v-if="msg" :error="msg"></alert-message>
            <v-card-text>
                <v-row>
                    <h3>Business Details</h3>
                    <v-col class="shrink" cols="12">
                        <v-text-field outlined v-model="vendor.businessName" :rules="businessNameRules"
                            label="Business Name*" required @input="slugUpdated($event)">
                            <tool-tip title="Name of Business" slot="append" />
                        </v-text-field>
                    </v-col>
                    <!-- <v-col class="shrink" cols="12">
                        <v-text-field outlined v-model="vendor.address" :rules="businessAddRules"
                            label="Business Address*" required />
                    </v-col> -->
                    <!-- <v-col class="shrink" cols="6">
                        <v-text-field outlined v-model="vendor.mobileNo" label="Business Contact Number" lazy />
                    </v-col> -->
                    <v-col class="shrink" cols="12  ">
                        <v-text-field outlined v-model="vendor.email" :rules="emailRules" label="Business email*"
                            type="Email address">
                            <tool-tip
                                title="This email address will be used for sending all billing communication, all auto-generated reports etc."
                                slot="append" />
                            <v-btn :style="theme" v-if="!verificationEmailSent" class="base-inverted" small
                                @click="verifyEmail()" slot="append">Validate</v-btn>
                        </v-text-field>
                    </v-col>
                    <v-col class="shrink" cols="12" v-if="verificationEmailSent">
                        <v-text-field outlined type="number" v-model="verificationCode" label="Verification Code*"
                            required>
                            <template v-slot:append>
                                <v-btn :style="theme" small class="base-inverted" v-if="!codeVerified"
                                    @click="verifyCode()">Verify</v-btn>
                                <v-icon color="green" v-else>mdi-check-bold</v-icon>
                            </template>
                        </v-text-field>
                        <label style="color:green">Please enter verification code received on {{ vendor.email }}</label>
                    </v-col>
                    <v-col class="shrink" cols="12">
                        <v-text-field outlined v-model="vendor.slug" label="OnlineDukan URL *"
                            @input="slugUpdated($event)"
                            hint="Field cannot contain any white space for special symbol, except '-'">
                            <tool-tip title="This will be unique URL to access your Business" slot="append" />
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <h5>Store URL :</h5><label>{{ vendor.url }}</label>
                    </v-col>
                    <v-col>
                        <h3 class="pb-4">Admin Details</h3>
                        <v-row>
                            <v-col class="shrink" cols="12" sm="6">
                                <v-text-field outlined :disabled="!codeVerified" v-model="vendor.admin.firstName"
                                    :rules="firstNameRules" label="FirstName*" />
                            </v-col>
                            <!-- <v-col class="shrink" cols="12" sm="4">
                                <v-text-field outlined :disabled="!codeVerified" v-model="vendor.admin.middleName"
                                    label="MiddleName" />
                            </v-col> -->
                            <v-col class="shrink" cols="12" sm="6">
                                <v-text-field outlined :disabled="!codeVerified" v-model="vendor.admin.lastName"
                                    :rules="lastNameRules" label="LastName*" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="shrink" cols="12" sm="6">
                                <v-text-field outlined :disabled="!codeVerified" v-model="vendor.admin.mobileNo"
                                    :rules="mobileNoRules" label="Mobile Number*" />
                            </v-col>
                            <v-col class="shrink" cols="12" sm="6">
                                <v-text-field outlined :disabled="!codeVerified" v-model="vendor.admin.email"
                                    :rules="emailRules" label="email*" type="Email address" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="shrink" cols="12" sm="6">
                                <v-text-field outlined :disabled="!codeVerified" v-model="vendor.admin.password"
                                    :rules="passwordRules" label="Password*" type="password" />
                            </v-col>
                            <v-col class="shrink" cols="12" sm="6">
                                <v-text-field outlined type="password" v-model="confirmPassword" :rules="passwordRules"
                                    required label="Confirm Password*" :disabled="!codeVerified"></v-text-field>
                                <label v-if="!passwordMatched" style="color:red">Password and confirm password should
                                    match</label>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <alert-message v-if="msg" :error="msg"></alert-message>
            <v-card-actions>
                <v-btn :style="theme" class="base-inverted" block @click="registerVendor()">Register</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>


<script>
import appConstants from '@/utils/appConstants'
import ToolTip from '@/components/ToolTipComponent.vue'
export default {
    components: {
        ToolTip
    },
    data() {
        return {
            vendor: this.defaultVendorObj(),
            verificationEmailSent: false,
            codeVerified: false,
            verificationCode: undefined,
            msg: "",
            validOrg: true,
            confirmPassword: ""
        }
    },
    computed: {
        passwordMatched() {
            return this.vendor.admin.password == this.confirmPassword
        }
    },
    methods: {
        defaultVendorObj() {
            return {
                businessName: "",
                address: "",
                mobileNo: "",
                email: "",
                url: '',
                slug: '',
                admin: {
                    firstName: "",
                    middleName: "",
                    lastName: "",
                    mobileNo: "",
                    password: "",
                    email: ""
                },
            }
        },
        generateSlug(value) {
            return value.trim().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, '')
        },
        slugUpdated(value) {
            this.vendor.slug = this.generateSlug(value)
            this.vendor.url = this.generateUrl(this.vendor.slug)
        },
        async verifyEmail() {
            try {
                await this.postItem(appConstants.WEBSTORE_VENDOR_API + "/verify-email", {
                    email: this.vendor.email
                });
                this.verificationEmailSent = true
            } catch (error) {
                this.handleError(error);
                console.error(error);
                this.msg = error.response;
            }
        },
        async verifyCode() {
            try {
                await this.postItem(appConstants.WEBSTORE_VENDOR_API + "/verify-code", {
                    email: this.vendor.email,
                    code: this.verificationCode
                });
                this.codeVerified = true
            } catch (error) {
                this.handleError(error);
                this.msg = error.response.data
            }
        },
        async registerVendor() {
            this.msg = ""
            if (this.$refs.vendorForm.validate() && this.passwordMatched && this.codeVerified) {
                try {
                    let admin=this.vendor.admin
                    this.vendor = await this.postItem(appConstants.WEBSTORE_VENDOR_API + "/registration", this.vendor);
                    this.vendor['admin']=admin
                    this.$emit('success', this.vendor)
                } catch (error) {
                    this.handleError(error);
                    this.msg = error.response.data;
                }
            }
        }
    },
}
</script>


<style lang="scss" scoped>
h3 {
    font-weight: bold;
}

.shrink {
    padding: 0 12px !important;
}
</style>
